import { isCountryCode } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';

const checkCountryCode = (value?: string | null): value is Iso3166TwoDigitCountryCode => {
  if (!value) {
    return false;
  }
  return isCountryCode(value);
};

export default checkCountryCode;
